// /goodbye — where a deleted account lands.
//
// A signed-OUT page, and that is the whole reason it exists. `deleteAccount()`
// drops the tokens before returning, so routing anywhere else would render the
// signed-in shell for an account that no longer resolves, and the first API call
// the page made would fail as an authentication error — which reads as "something
// went wrong" at the exact moment the user needs to be told it worked.
//
// It is in PUBLIC_PATHS for the same reason: an unauthenticated visitor here must
// not be bounced to /login, because they have just been deliberately signed out.
//
// It says what was kept, because App Store review reads this flow and because the
// user deserves the same answer /privacy gives.

import { el } from '../dom.js';
import type { View } from '../router.js';
import { brandName } from '../brand.js';

export const goodbyeView: View = (outlet) => {
  outlet.append(
    el('main', { class: 'page' }, [
      el('h1', {}, 'Your account is closed'),
      el(
        'p',
        {},
        'You have been signed out on every device. Your email address and phone ' +
          'number are gone, and you have left every group.',
      ),
      el(
        'p',
        { class: 'muted' },
        'Your first and last name stay on the posts, events and results other ' +
          'members can still see, so their own history stays readable. ' +
          'Nothing else about you is kept.',
      ),
      el('p', {}, [
        'You can sign up again with the same email address whenever you like. ',
        el('a', { href: '/register' }, `Create a new ${brandName()} account`),
        '.',
      ]),
      el('p', { class: 'muted small' }, [
        el('a', { href: '/privacy' }, 'Privacy Policy'),
        ' · ',
        el('a', { href: '/contact' }, 'Contact us'),
      ]),
    ]),
  );
};
